import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!../../templates/generic-tile.html';
import styles from './_wizard-tile-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            state: '&',
            callback: '&',
            flavor: '@',
            icon: '@'
        },
        transclude: {
            'footer': '?gwTileFooter',
            'actions': '?gwTileAction',
            'content': 'gwTileContent'
        },
        template: cssUtil.hashTemplate(template, styles),
        controller: ['$scope', 'tiles.tilesUtilFunctions', function ($scope, tilesUtilFunctions) {
            $scope.tileType = 'wizard';
            $scope.customFlavor = $scope.flavor || 'Default';
            $scope.allow = {
                header: false,
                content: true,
                actions: true,
                footer: true
            };

            $scope.clickCallback = function () {
                var currentState = $scope.state();
                // Can invoke callback when not in the active state and editable
                if (currentState !== 'active' && currentState !== 'disabled') {
                    $scope.callback();
                }
            };

            $scope.getActiveState = tilesUtilFunctions.getActiveStateFunction($scope.state);
            $scope.getStyle = tilesUtilFunctions.getStyleFunction(styles);
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/Wizard/wrapper/_WizardTile.js
// module id = 1164
// module chunks = 0